import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignal = () => {

return(
<div>
    
<Typography variant="h6" >

The traffic light system (green, orange, red) indicates how many of the six FTO genes variants are detected and impact obesity.
<br /><br />                        rs9939609 &nbsp;    --&nbsp;&nbsp; obesity risk and 1.6x risk for T2D
<br />                        rs1558902 &nbsp;    -- &nbsp;&nbsp;Higher BMI than normal -- precision nutrition: high protein diet --   high-protein diet may be beneficial for weight loss and improvement of body composition   
<br />                        rs1421085  &nbsp;   -- &nbsp;&nbsp;clinvar: risk-factor;   SNPedia: ~1.7x increased obesity risk
<br />                        rs1121980  &nbsp;   --&nbsp;&nbsp; Moderate increase (2.76x) in risk for obesity
<br />                        rs17817449     -- &nbsp;&nbsp;1.7x increased obesity risk
<br />       &nbsp;

 
</Typography>

</div>
)
}